import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemsListHeadItemLabelComponent } from '@fi-app/components/items-list/head-item/head-item-label/head-item-label.component';

@Component({
    selector: 'fi-checklist-report-last-active-period-status-header',
    templateUrl: './checklist-report-last-active-period-status-header.component.html',
    styleUrls: ['./checklist-report-last-active-period-status-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ChecklistReportLastActivePeriodStatusHeaderComponent extends ItemsListHeadItemLabelComponent {}
